// extracted by mini-css-extract-plugin
module.exports = {"panel":"HiringAssessmentsPanel-module__panel___2Kusn"};